<template>
  <div>
    <h1 class="ma-2">
      บริการคอร์ส
    </h1>
    <v-container>
      <search-bar
        ref="searchBar"
        :status="status"
        :action-persmission="userType === 'ADMIN'"
        action-text="เพิ่มบริการคอร์ส"
        action-icon="fas fa-plus"
        @onStatusChange="onStatusChange"
        @search="search"
        @onSearchActionButtonClick="$router.push('/admin/courses/create')"
      />
      <v-row v-if="items.length > 0">
        <v-col
          v-for="item in items"
          :key="item._id"
          cols="12"
          sm="4"
          md="3"
        >
          <v-card>
            <v-img
              v-if="item.image"
              class="white--text"
              height="200px"
              :src="item.image"
            >
              <v-card-title class="align-end fill-height">
                {{ item.name }}
              </v-card-title>
            </v-img>
            <v-img
              v-else
              class="white--text"
              height="200px"
              src="https://firebasestorage.googleapis.com/v0/b/thesis-5b315.appspot.com/o/spa-manage%2Fplaceholder.jpg?alt=media"
            >
              <v-card-title class="align-end fill-height">
                {{ item.name }}
              </v-card-title>
            </v-img>
            <v-card-text>
              <span>เวลาที่ใช้: {{ item.time }} นาที</span><br>
              <span>ราคา: {{ item.price }} บาท</span><br>
              <span>
                สถานะ:
                <span
                  v-if="item.status === 'ACTIVE'"
                  class="green--text"
                >
                  &#x25cf; เปิดใช้งาน
                </span>
                <span
                  v-if="item.status === 'INACTIVE'"
                  class="yellow--text"
                >
                  &#x25cf; ปิดใช้งาน
                </span>
              </span>
            </v-card-text>
            <v-card-actions v-if="userType === 'ADMIN'">
              <v-btn
                text
                color="orange"
                @click="$router.push(`courses/${item._id}`)"
              >
                แก้ไขบริการ
              </v-btn>
              <v-btn
                v-if="item.status === 'ACTIVE'"
                text
                color="yellow"
                @click="updateStatus(item._id, 'INACTIVE')"
              >
                ปิดใช้งาน
              </v-btn>
              <v-btn
                v-if="item.status === 'INACTIVE'"
                text
                color="green"
                @click="updateStatus(item._id, 'ACTIVE')"
              >
                เปิดใช้งาน
              </v-btn>
              <v-spacer />
              <v-btn
                icon
                color="red"
                @click="deleteCourse(item._id)"
              >
                <v-icon small>
                  fas fa-trash
                </v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        v-else
        class="mt-5"
      >
        <v-col
          justify-self="center"
          align-self="center"
        >
          <center>
            <v-icon x-large>
              fas fa-dizzy
            </v-icon>
            <h1 class="font-weight-thin">
              ไม่พบข้อมูล
            </h1>
          </center>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SearchBar from '@/components/SearchBar.vue';
import http from '@/http';
import { SET_ALERT, SET_ERROR, SET_ALERT_CONTEXT } from '@/store/mutation_types';

export default {
  name: 'CourseListView',
  components: {
    SearchBar,
  },
  data() {
    return {
      status: '',
      formDialog: false,
      items: [],
      selectedcourse: '',
    };
  },
  computed: {
    ...mapGetters(['loading', 'userType']),
  },
  watch: {
    async status(value) {
      if (value) {
        this.$refs.searchBar.onSearch();
      }
    },
  },
  async mounted() {
    this.status = 'All';
    this.$refs.searchBar.onSearch();
  },
  methods: {
    ...mapActions([SET_ALERT, SET_ERROR, SET_ALERT_CONTEXT]),
    async updateStatus(id, status) {
      await http.put(`/courses/${id}`, { status });
      this.$refs.searchBar.onSearch();
      this.SET_ALERT(true);
      this.SET_ERROR(false);
      this.SET_ALERT_CONTEXT('อัพเดทสถานะบริการคอร์สแล้ว');
    },
    async search(value) {
      const result = await http.get(`/courses?name=${value.text}&status=${value.status}`);
      this.items = [...result.data];
    },
    onStatusChange(value) {
      this.status = value;
    },
    async deleteCourse(id) {
      await http.delete(`/courses/${id}`);
      this.$refs.searchBar.onSearch();
      this.SET_ALERT(true);
      this.SET_ERROR(false);
      this.SET_ALERT_CONTEXT('ลบบริการคอร์สแล้ว');
    },
  },
};
</script>
